export default function() {
    const buttons = document.querySelectorAll('[data-shows-card]')

    if (!buttons.length) return

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            buttons.forEach(button => {
                button.classList.remove('tabbed-card__button--active')
            })
    
            button.classList.add('tabbed-card__button--active')
    
            document.querySelectorAll('[data-card]').forEach(card => {
                card.classList.add('hidden')
            })
    
            document.querySelector(`[data-card="${button.dataset.showsCard}"]`).classList.remove('hidden')
        })
    })
}